import React from 'react';
import MaterialMediaGrid from './MaterialMediaGrid';
import MaterialMediaList from './MaterialMediaList';
import MediaToolBar from './MediaToolBar';
import NoMaterialContent from './NoContent';

const AttendeeMedia = props => {
	const {
		viewType,
		media,
		event,
		library,
		handleMediaFilter,
		changeSortOrder,
		setViewType,
		fileTypes,
		sortOrder,
		handlePickItem,
	} = props;

	return (
		<div className="material-media">
			<MediaToolBar
				sortOrder={sortOrder}
				changeSortOrder={changeSortOrder}
				handleMediaFilter={handleMediaFilter}
				setViewType={setViewType}
				viewType={viewType}
				fileTypes={fileTypes}
			/>
			{!media.length ? (
				<NoMaterialContent iconType={'media'} />
			) : viewType === 'gridView' ? (
				<MaterialMediaGrid
					media={media}
					event={event}
					linkType={'eventMedia'}
					library={library}
					handlePickItem={handlePickItem}
				/>
			) : (
				<MaterialMediaList
					media={media}
					event={event}
					linkType={'eventMedia'}
					library={library}
					handlePickItem={handlePickItem}
				/>
			)}
		</div>
	);
};

export default AttendeeMedia;
